import React, { useState, useEffect } from 'react';
import { Input } from 'reactstrap';
import SwiperCore, { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Container, Col, Row } from 'reactstrap';
import { isMobile } from 'react-device-detect';
import CategoryItem from '../../Shared/CategoryItem/CategoryItem'

const CategoriesList = (props) => {

    return (
        <div className='categories-list'>

        <div style={{ textAlign: 'center', paddingRight: '15px' }}>

            <Row>
                <Col>{props.title && <h1>{props.title}</h1>}</Col>
            </Row>
            <div className="sparator"></div>
         
            <div className="inner">
                 <div className="items-container">

                 {props.items.map((item, i) => (
                    <CategoryItem key={i} data={item} onClickCategory={props.onClickCategory} />
                 ))}

                </div>
            </div>

        </div>
    </div>
    );
};

export default CategoriesList;
